<template>
  <div></div>
</template>
<script>
import AuthService from '@/service/auth/authService';

export default {
  name: 'Logout',
  mounted() {
    this.signOut();
  },
  methods: {
    signOut() {
      AuthService.logout().catch(function () {
        // clearSession and redirect already handled in AuthService.logout()
      });
    },
  },
};
</script>
